import React from "react";
import { links } from "../../config/links";

const recursos = [
  {
    titulo: "Seu cliente compra sozinho",
    texto:
      "O produtor vinculado à sua empresa vê o catálogo, monta o pedido e fecha. Chega pronto no painel, sem precisar de representante na porta dele.",
  },
  {
    titulo: "Catálogo com CIF e FOB",
    texto:
      "Cadastre o produto com as embalagens, preço por embalagem, quantidade mínima, frete por km e as janelas de pagamento e entrega.",
  },
  {
    titulo: "Integração com o seu ERP",
    texto:
      "O pedido fechado no app entra no seu sistema, com endereço de entrega, tipo de frete e duplicata. Produto e preço sincronizam do ERP para o app.",
  },
  {
    titulo: "Filiais e vendedores",
    texto:
      "Cada unidade com o seu catálogo e a sua região. Vendedores acessam só o que é da unidade deles.",
  },
  {
    titulo: "WhatsApp no mesmo lugar",
    texto:
      "As conversas com o produtor ficam no painel, junto do pedido, não no celular de um vendedor só.",
  },
  {
    titulo: "Recebimento e repasse",
    texto:
      "PIX e boleto emitidos pela plataforma. No cadastro você informa a conta ou a chave PIX que recebe o repasse.",
  },
  {
    titulo: "Devoluções pelo painel",
    texto:
      "A solicitação chega com foto e motivo. Você aprova, recusa ou combina a coleta, e o produtor acompanha.",
  },
  {
    titulo: "Painel de vendas",
    texto:
      "Pedidos por status, faturamento e o que está em separação, por unidade.",
  },
];

const Parceiro: React.FC = () => (
  <section id="parceiro" className="border-b border-soil-700 bg-soil">
    <div className="mx-auto max-w-site px-5 py-16 lg:px-8 lg:py-24">
      <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <p className="eyebrow-light">Para quem vende no app</p>
          <h2 className="mt-4 font-display text-display-md font-bold text-white">
            Venda mais sem
            <br />
            aumentar o time.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/70">
            O produtor abre o app, vê o seu preço e fecha o pedido sozinho. Você
            publica o catálogo uma vez e recebe pedido pronto, com endereço de
            entrega e forma de pagamento definidos.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a href={links.partnerSignup} className="cta-gold">
              Cadastrar minha empresa
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M3 7.5h9M8.5 4l3.5 3.5L8.5 11" />
              </svg>
            </a>
            <a href={links.whatsapp} target="_blank" rel="noopener noreferrer" className="cta-ghost-light">
              Falar no WhatsApp
            </a>
          </div>

          <div className="mt-8 border-l-2 border-soy pl-4">
            <p className="font-display text-base font-bold text-white">
              Seu preço não fica na vitrine
            </p>
            <p className="mt-1.5 max-w-md text-sm leading-relaxed text-white/60">
              O catálogo aparece dentro do app, só para os produtores vinculados
              à sua empresa. Não é página aberta, não indexa em buscador e o
              concorrente não vê a sua tabela.
            </p>
          </div>

          <p className="mt-6 max-w-md text-sm leading-relaxed text-white/50">
            O cadastro pede os dados da empresa, endereço, dados fiscais, conta
            para repasse e o aceite do contrato de adesão. Depois de aprovado,
            seu acesso ao painel é liberado por e-mail.
          </p>
        </div>

        <ul className="grid gap-px border border-soil-600/50 bg-soil-600/50 sm:grid-cols-2">
          {recursos.map((r) => (
            <li key={r.titulo} className="bg-soil-800 p-6">
              <h3 className="font-display text-base font-bold text-white">
                {r.titulo}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60">{r.texto}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);

export default Parceiro;
